// Add all the other applications (key) with corresponding language (value) below
// The locale needs to match the language code that is set up in Centra.
const transformLocale = (locale: string) => {
    const locales: { [key: string]: string } = {
        'en': 'en',
        'no': 'no',
    };
    return locales[locale] || 'en';
};

export default transformLocale;
